import $ from "jquery";
import modalUpdate from './modal-update.js';
import ellipsis from './components/ellipsis.js';
// ---------------------------------------------------------
// Custom Functions for Back-End
// ---------------------------------------------------------


// ==============================================================
// Global variables
// ==============================================================
const g_domain = window.location.origin;

if (window.currentPage == 'order_detail_expert') {
  $('.jsChooseExpert').click(async function (e) {
    e.preventDefault()
    var id = $(this).data('id')
    var type = $(this).data('type')
    var url = $(this).attr('href')
    await $.ajax({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },
      url: '/assign-expert',
      data: { 'id': id, 'type': type },
      type: 'post',
      dataType: "json",
      beforeSend: function () {
      },
    }).done(function (res) {
      window.location.href = url
    });
  })
}

if (window.currentPage == 'order_expert_list') {
  var page = null;
  var expert_range_specialty_field = [];
  var birth_day = '';
  var type_use = '';
  var last_login_date = '';
  var time_can_work = '';
  var minimum_wage_by_hour_from = '';
  var minimum_wage_by_hour_to = '';
  var keyword = '';

  ellipsis({
    element: '.ellipsis3',
  });

  $(document).ready(function () {
    // begin order_expert_list

    function chooseExpert(elm) {
      var id = $(elm).val()
      var type = $(elm).data('type')
      $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/assign-experts',
        data: { 'id': id, 'type': type },
        type: 'post',
        dataType: "json",
        beforeSend: function () {
        },
      }).done(function (res) {
      });
    }

    function checkboxListState(checkboxEls) {
      let isChecked = false;
      checkboxEls.forEach(checkboxEl => {
        if (checkboxEl.checked) {
          isChecked = true;
          return false;
        }
      });
      return isChecked;
    }
    function checkboxList() {
      let checkboxEls = document.querySelectorAll('.jsCheckbox'),
        stickyBtnEl = document.getElementById('jsStickyBtn');
      if (checkboxEls.length > 0) {
        checkboxEls.forEach(checkboxEl => {
          if(checkboxEl.checked || expert_asigns.length > 0){
            stickyBtnEl.classList.add('sticky');
          }
          checkboxEl.addEventListener('change', function () {
            if (checkboxListState(checkboxEls)) {
              stickyBtnEl.classList.add('sticky');
            } else {
              stickyBtnEl.classList.remove('sticky');
            }
            chooseExpert($(checkboxEl))
          });
        });
      }
    }

    function get_order_expert_list() {
      window.location.reload();
    }

    $('#jsNavSider3 .item.skillParrent, #jsNavSider3 .item1.skill').on('click', function (e) {
      e.stopPropagation();
      $('#jsNavSider3 .item').removeClass('active');
      // $(this).closest('.item').toggleClass('active');

      expert_range_specialty_field = [];

      if (e.target.tagName == 'A') {
        expert_range_specialty_field.push(e.target.parentElement.getAttribute("value"));
      }

      if (e.target.tagName == 'SPAN') {
        e.target.nextElementSibling.querySelectorAll('li').forEach(item => {
          expert_range_specialty_field.push(item.getAttribute("value"));
        });
      }
      e.preventDefault();

      setOldParameter('expert_range_specialty_field');
      changeUrlParameter();
      get_order_expert_list();
    })

    $("body").on("submit", "#formSearchKeyWordOrderExper", function (pre) {
      pre.preventDefault();
      keyword = $('#search').val();

      setOldParameter('keyword');
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#birthdaySelect").change(function () {
      birth_day = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#roleSelect").change(function () {
      type_use = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#lastLoginSelect").change(function () {
      last_login_date = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#timeCanWorkSelect").change(function () {
      time_can_work = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#minimumWageFromSelect").change(function () {
      minimum_wage_by_hour_from = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $("#minimumWageToSelect").change(function () {
      minimum_wage_by_hour_to = $(this).val();

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    $(document).on('click', 'span.paginationItem, span.paginationNext, span.paginationPrev', function (event) {
      event.preventDefault();
      page = $(this).data("value");

      setOldParameter();
      changeUrlParameter();
      get_order_expert_list();
    });

    function changeUrlParameter() {
      var url = new URL(window.location.href)
      var search_params = url.searchParams;

      // Delete old params
      search_params.delete('keyword');
      search_params.delete('expert_range_specialty_field');
      search_params.delete('page');
      search_params.delete('birth_day');
      search_params.delete('type_use');
      search_params.delete('last_login_date');
      search_params.delete('time_can_work');
      search_params.delete('minimum_wage_by_hour_from');
      search_params.delete('minimum_wage_by_hour_to');


      // Add new params
      if (keyword) {
        search_params.append('keyword', keyword);
      }

      if (birth_day) {
        search_params.append('birth_day', birth_day);
      }

      if (expert_range_specialty_field !== undefined && expert_range_specialty_field.length !== 0) {
        search_params.append('expert_range_specialty_field', expert_range_specialty_field);
      }

      if (type_use) {
        search_params.append('type_use', type_use);
      }

      if (last_login_date) {
        search_params.append('last_login_date', last_login_date);
      }

      if (time_can_work) {
        search_params.append('time_can_work', time_can_work);
      }

      if (minimum_wage_by_hour_from) {
        search_params.append('minimum_wage_by_hour_from', minimum_wage_by_hour_from);
      }

      if (minimum_wage_by_hour_to) {
        search_params.append('minimum_wage_by_hour_to', minimum_wage_by_hour_to);
      }

      if(page) {
        search_params.append('page', page);
      }

      url.search = search_params.toString();
      var new_url = url.toString();
      window.history.pushState({ additionalInformation: 'Updated the URL with JS' }, "Title", new_url);
    }

    function getUrlParameter() {
      var vars = {}, hash;
      var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        if (hash[0] in vars) {
          vars[hash[0]] += ',' + hash[1];
          continue;
        }
        vars[hash[0]] = hash[1];
      }

      return vars;
    };

    function setOldParameter(text) {
      var params = getUrlParameter()
      if (text != 'keyword') {
        keyword = $('#search').val();
      }

      if (text != 'expert_range_specialty_field') {
        expert_range_specialty_field = (expert_range_specialty_field != undefined && expert_range_specialty_field.length !== 0) ? expert_range_specialty_field : params.expert_range_specialty_field
      }

      birth_day = (birth_day && birth_day.length !== 0) ? birth_day : params.birth_day
      type_use = (type_use && type_use.length !== 0) ? type_use : params.type_use
      last_login_date = (last_login_date && last_login_date.length !== 0) ? last_login_date : params.last_login_date
      time_can_work = (time_can_work && time_can_work.length !== 0) ? time_can_work : params.time_can_work
      minimum_wage_by_hour_from = (minimum_wage_by_hour_from && minimum_wage_by_hour_from.length !== 0) ? minimum_wage_by_hour_from : params.minimum_wage_by_hour_from
      minimum_wage_by_hour_to = (minimum_wage_by_hour_to && minimum_wage_by_hour_to.length !== 0) ? minimum_wage_by_hour_to : params.minimum_wage_by_hour_to
    }
    // end order_expert_list
    checkboxList();
  });
}

$(document).ready(function () {

  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });
  var orderError = {
    errorFields: function (field, message) {
      $("." + field)
        .show()
        .text(message);
    },
    hideFields: function (field) {
      $("." + field).hide();
    },
    scrollTop: function () {
      $(window).scrollTop(0);
    },
  };

  $("body").on("submit", "#frmOrderProfile, #frmOrderProfileCorp", function (pre) {
    pre.preventDefault();
    $("#frmOrderProfile .textError, #frmOrderProfileCorp .textError").hide();
    let url = $(this).attr("action")
    let method = $(this).attr("method")
    var fd = new FormData(this)
    fd.append('_token', $('meta[name="csrf-token"]').attr("content"))
    return $.ajax({
      url: url,
      data: fd,
      type: method,
      dataType: "json",
      processData: false,
      contentType: false,
      beforeSend: function () {
      },
    }).done(function (res) {
      if (res.status == "error") {
        orderError.scrollTop();
        $.each(res.message, function (key, value) {
          orderError.errorFields(key, value);
        });
      }else if (res.status == false) {
        $('.modalUpdate > .wrap > .text').html('更新に失敗しました。');
        $('.modalUpdate > .wrap > .btnUpdate').css("display", "none");
        modalUpdate({
          button_id: 'jsTriggerModal',
          modal_id: 'modalUpdate',
          overlay_id: 'overplay'
        });
      } else {
        if (pre.target.getAttribute('id') == 'frmOrderProfileCorp') {
          $('.sidebarImg').children('img').attr('src', (res.new_image ?? '/assets/img/expert/profile/icon_corp_default.jpg'))
          $("input[name='company_logo']").val(res.new_image ?? '/assets/img/expert/profile/icon_corp_default.jpg');
          $('p.nameOrderCorp').text(res.name ?? '');
        } else {
          $('.sidebarImg, .navAvatarImg').children('img').attr('src', (res.new_image ?? '/assets/img/expert/profile/icon_default.jpg'))
          $("input[name='company_logo']").val(res.new_image ?? '/assets/img/expert/profile/icon_default.jpg');
          $('p.nameOrder').text(res.name ?? '');
        }
        modalUpdate({
          button_id: 'jsTriggerModal',
          modal_id: 'modalUpdate',
          overlay_id: 'overplay'
        });
      }
    });
  });

  // page order invite
  if (window.currentPage == 'order_invite') {
    $('.jsInviteSomeone').click(function (e) {
      e.preventDefault();
      var url = $(this).data('url')
      var data = {
        first_name: $('#frmInviteSomeone').find('input[name="first_name"]').val(),
        last_name: $('#frmInviteSomeone').find('input[name="last_name"]').val(),
        email: $('#frmInviteSomeone').find('input[name="email"]').val(),
      };
      return $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        data: data,
        type: 'post',
        dataType: "json",
        beforeSend: function () {
        },
        success: function (res) {
          $('.textError').remove()
          if (res.status == true) {
            var html = '<tr> <td>' + res.data.first_name + ' ' + res.data.last_name + '</td><td> <p class="checkbox checkbox01"> <input class="checkItem" type="checkbox" id="cancel13" name="cancel[]" value="' + res.data.id + '"> <label for="cancel13">キャンセル</label> </p> </td> </tr>';
            $('.tableMember tr:first').after(html)
            $('#popup01').removeClass('show');
            $('#frmInviteSomeone').find('input').val('')
            $('#modalUpdate .text').html("招待する方のメールアドレスへ<br>登録案内のメールをお送りました。")
            modalUpdate({
              button_id: 'jsTriggerModal',
              modal_id: 'modalUpdate',
              overlay_id: 'overplay'
            });
          } else {
            alert(res.message)
          }
        }
      }).fail(function (xhr, textStatus, errorThrown) {
        var message = JSON.parse(xhr.responseText)
        $('.textError').remove()
        if (message.errors.first_name) {
          $('#frmInviteSomeone').find('input[name="first_name"]').parent().append('<p class="textError first_name show">' + message.errors.first_name[0]+ '</p>');
        }
        if (message.errors.last_name) {
          $('#frmInviteSomeone').find('input[name="last_name"]').parent().append('<p class="textError last_name show">' + message.errors.last_name[0]+ '</p>');
        }
        if (message.errors.email) {
          $('#frmInviteSomeone').find('input[name="email"]').parent().append('<p class="textError email show">' + message.errors.email[0]+ '</p>');
        }
      });
    })

    $('.jsCancelInvite').click(function (e) {
      e.preventDefault();
      var url = $(this).data('url')
      var ids = [];
      $.each($("input[name='cancel[]']:checked"), function () {
        ids.push($(this).val());
      });
      return $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        data: { ids: ids },
        type: 'post',
        dataType: "json",
        beforeSend: function () {

        },
      }).done(function (res) {
        alert('キャンセルしました。');
        window.location.reload();
      });
    })

    $('.jsDeleteMember').click(function (e) {
      e.preventDefault();
      if (confirm("本当に削除してもよろしいですか？")) {
        var url = $(this).attr('href')
        return $.ajax({
          headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          },
          url: url,
          type: 'post',
          dataType: "json",
          success: function (result) {
            if (result.status == true) {
              $('.jsDeleteMember[href="' + url + '"]').parents('tr').remove()
              alert('発注者を削除しました。')
            }else{
              alert('異常が起こりました。後でもう一度試してみてください。')
            }
          },
        }).fail(function (xhr, textStatus, errorThrown) {
          alert('異常が起こりました。後でもう一度試してみてください。')
        });
      }
    })

    $(".jsInviteManyOrder, #jsCheckCsv").on('click', function (e) {
      e.preventDefault();
      var fd = new FormData();
      var files = $('#jsBrowseFile').prop('files');
      var url = $(this).attr('data-url')
      fd.append('file', files[0]);
      $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: url,
        type: "post",
        data: fd,
        contentType: false,
        processData: false,
        success: function (result) {
          if (result.status == true) {
            if (result.check == false) {
              window.location.href = '/order/corp-authority/invite'
              $(".jsInviteManyOrder").attr('disabled', 'disabled');
              $('#jsBrowseFile').val('');
              $('#modalUpdate .text').text('アイレップ社員を招待しました。')
              modalUpdate({
                button_id: 'jsCheckCsv',
                modal_id: 'modalUpdate',
                overlay_id: 'overplay'
              });
            } else {
              $('#tableMember').html('')
              var html = ''
              $.each(result.data, function (key, item) {
                html += '<tr> <td>' + item.first_name + item.last_name + '</td> <td>' + item.email + '</td></tr>';
              });
              $('#tableMember').append(html)
              $(".jsInviteManyOrder").removeAttr('disabled');
            }
          }
        }
      }).fail(function (xhr, textStatus, errorThrown) {
        var message = JSON.parse(xhr.responseText)
        var errors = '';
        if ('errors' in message) {
          $.each(message.errors, function (key, error) {
            errors += '<br>' + error;
          });
        } else {
          errors = message.join('<br>');
        }
        $('#modalUpdate .text').html(errors)
        modalUpdate({
          button_id: 'jsCheckCsv',
          modal_id: 'modalUpdate',
          overlay_id: 'overplay'
        });
        $(".jsInviteManyOrder").attr('disabled', 'disabled');
      });
    });
  }
  // end page order invite

  if (window.currentPage == 'order_expert_list' || window.currentPage == 'order_detail_expert') {
    $('.jsFavorite').on('click', function() {
      let that = $(this);
      var type = $(this).data('type');
      var id = $(this).data('id');
      return $.ajax({
        headers: {
          'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        },
        url: '/add-favorite',
        data: {
          'id': id,
          'type': type
        },
        type: 'post',
        dataType: "json",
        beforeSend: function () {
          that.addClass('loading');
        },
      }).done(function (res) {
        that.removeClass('loading');
      });
    })
  }
})
